import { NgModule } from '@angular/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { MenuButtonComponent } from './menu-button.component';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';

@NgModule({
	imports: [
		GoMaterialModule,
		CommonModule,
		MenuModule
	],
	declarations: [
		MenuButtonComponent
	],
	exports: [
		MenuButtonComponent
	]
})
export class MenuButtonModule {}
